export enum FilterRoles {
  Admin = "Admin",
  Supplier = "Supplier",
  SupplierSale = "SupplierSale",
  AdviserUser = "AdviserUser",
}
